import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-insurance-modal',
  templateUrl: './insurance-modal.component.html',
  styleUrls: ['./insurance-modal.component.scss'],
})
export class InsuranceModalComponent implements OnInit {
  @Input () modeFrom:string;
  @Input () message:string;
  @Input () headerTitle:string;
  @Input () infoDescription:string;
  @Input () validToDate:string;
  @Input () validUntillDate:string;
  constructor(private mdlCtrl:ModalController) { }

  ngOnInit() {}

  back(){
    this.mdlCtrl.dismiss();
  }

  actionMethod(data:string){
    this.mdlCtrl.dismiss(data)
  }

  

}
